module.exports = __webpack_public_path__ + "static/media/talita.96847545.jpg";